import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeToken, isAuthenticated } from '@/utils/auth';
import { toast } from 'sonner';

export const AutoLogout = ({ children }) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds

  const logout = useCallback(() => {
    removeToken();
    toast.info('You have been logged out due to inactivity');
    navigate('/');
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    if (isAuthenticated()) {
      timeoutRef.current = setTimeout(() => {
        logout();
      }, INACTIVITY_TIMEOUT);
    }
  }, [logout, INACTIVITY_TIMEOUT]);

  useEffect(() => {
    if (!isAuthenticated()) return;

    // Events that indicate user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    // Reset timer on any user activity
    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    // Start the initial timer
    resetTimer();

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [resetTimer]);

  return <>{children}</>;
};
